import { getWMJSLayerById, getWMJSMapById, WEBMAPJS_SERVICE_SET_LAYERS } from '@adaguc/react-webmapjs';
import { produce } from 'immer';
/* Constants */
export const SELECT_SPI = 'SELECT_SPI';
export const SELECT_SPI_TIME = 'SELECT_SPI_TIME';
export const HANDLE_ERROR = 'HANDLE_ERROR';
export const DISMISS_ERROR = 'DISMISS_ERROR';
export const L13_READY = 'L13_READY';
export const SPI_LOADING = 'SPI_LOADING';

export const SPI_MONITOR_REDUCERNAME = 'SPI_MONITOR_REDUCERNAME';

/* Actions creators */
export const selectSPIAction = obj => ({ type: SELECT_SPI, payload: obj });
export const setSpiMonitorTimeAction = obj => ({ type: SELECT_SPI_TIME, payload: obj });
export const handleErrorAction = (message, error) => ({ type: HANDLE_ERROR, payload: { message: message, error: error } });
export const dismissErrorAction = obj => ({ type: DISMISS_ERROR, payload: obj });
export const l13ReadyAction = obj => ({ type: L13_READY, payload: obj });
export const spiLoadingAction = obj => ({ type: SPI_LOADING, payload: obj });

/* Initial state */
const initialState = {
  selectedSPI: 'spi1',
  selectedSPITime: '',
  errors: [],
  loadingL13: true,
  spiIsLoading: false
};

/* Reducer which adds its data into the store; the location inside the store is specified by the reducer name and the id from the action */
export const spiMonitorReducer = (state = initialState, action = { type:null }) => {
  /* Standard reducer handling  */
  switch (action.type) {
    case WEBMAPJS_SERVICE_SET_LAYERS:
      getWMJSMapById('mapid_1').setActiveLayer(getWMJSLayerById('spiLayerDaily'));
      return state;
    case SELECT_SPI:
      return produce(state, draft => { draft.selectedSPI = action.payload; });
    case SELECT_SPI_TIME:
      return produce(state, draft => { draft.selectedSPITime = action.payload; });
    case HANDLE_ERROR:
      return produce(state, draft => { draft.errors.push({ error: action.payload.error, message: action.payload.message }); });
    case DISMISS_ERROR:
      return produce(state, draft => { draft.errors.length = 0; });
    case L13_READY:
      return produce(state, draft => { draft.loadingL13 = false; });
    case SPI_LOADING:
      return produce(state, draft => { draft.spiIsLoading = action.payload; });
    default:
      return state;
  }
};
